<template>
    <BaseDropdown position="left">
        <template #trigger>
            <ModuleTag
                v-if="searchModule"
                :icon="$getModuleIcon(searchModule.name)"
                :label="$t(searchModule.name + '.table.title')"
                :module="searchModule.name">
                <template
                    v-if="searchables?.length"
                    #append>
                    <Icon name="chevron-down" />
                </template>
            </ModuleTag>
            <ModuleTag
                v-else
                grayed-out
                icon="bars"
                :label=" $t('globalSearch.everything')">
                <template
                    v-if="searchables?.length"
                    #append>
                    <Icon name="chevron-down" />
                </template>
            </ModuleTag>
        </template>
        <BaseMenuItem @click="globalSearchStore.setCurrentModule(null)">
            <ModuleTag
                reduced
                grayed-out
                icon="bars"
                :label=" $t('globalSearch.everything')" />
            <span :class="{'font-bold': !searchModule?.name}">
                {{ $t('globalSearch.everything') }}
            </span>
        </BaseMenuItem>
        <BaseMenuItem
            v-for="searchable in searchables"
            :key="searchable"
            @click="globalSearchStore.setCurrentModule(searchable)">
            <ModuleTag
                reduced
                :icon="$getModuleIcon(searchable)"
                :label="$t(searchable + '.table.title')"
                :module="searchable" />
            <span :class="{'font-bold': searchModule?.name === searchable}">
                {{ $t(searchable + '.table.title') }}
            </span>
        </BaseMenuItem>
    </BaseDropdown>
</template>

<script setup>
import {useGlobalSearchStore} from '@/store/globalSearch'
import {$getModuleIcon, appModules} from "@/utils/appModules"

const globalSearchStore = useGlobalSearchStore()

const searchModule = computed(() => {
    if (globalSearchStore.currentModule === null) {
        return null
    }
    return appModules[globalSearchStore.currentModule] ?? null
})

const searchables = computed(() => Object.keys(appModules).filter(
    module => appModules[module]?.search && appModules[module].search !== true && appModules[module].search.detail
))
</script>
